import React, { useEffect, useState } from 'react'

import settingIcon from '../../assets/setting-icon.svg'
import arrowIcon from '../../assets/arrow-full.svg'
import { GiHockey } from 'react-icons/gi'
import { useSelector } from 'react-redux'
import { getLeagueStandings } from '../../redux'
import { useNavigate } from 'react-router-dom'
// import Loader from '../Loader'

const LeagueStandingsHockey = ({ maxHeight }) => {
  const setting = useSelector((state) => state?.user?.setting)

  const [standings, setStandings] = useState(null)
  // const [loading, setLoading] = useState(true)

  const navigate = useNavigate()

  useEffect(() => {
    getData()
  }, [setting?.date])

  const getData = async () => {
    // setLoading(true)
    console.log(setting)
    let data = await getLeagueStandings(setting?.date)
    // console.log('🚀 ~ file: index.js:27 ~ getData ~ data:', data)
    if (data) {
      setStandings(data)
      // setLoading(false)
    }
  }

  return (
    <div className='league_standings_box'>
      <header>
        <h3>League Standings</h3>
        <div style={{ display: 'flex', gap: '12px' }}>
          {/* <img src={settingIcon} style={{ cursor: 'pointer' }} /> */}
          <img
            src={arrowIcon}
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/league-standings')}
          />
        </div>
      </header>
      <section
        className='league_standings_body'
        style={{ maxHeight: maxHeight ? maxHeight : '1172px' }}
      >
        <div className='header'>
          <div className='header_1'>
            <h2>Rk</h2>
          </div>
          <div className='header_2'>
            <h2>Team</h2>
          </div>
          <div className='header_3'>
            <h2>Day</h2>
          </div>
          <div className='header_4'>
            <h2>Season</h2>
          </div>
        </div>
        {standings &&
          Object.entries(standings)?.map((v, i) => {
            return (
              <div key={i} className='league_standings_card_box'>
                <div className='heading'>{v[0]}</div>
                {v[1]
                  ?.sort((a, b) => b.teamScore?.teamScore?.pf - a.teamScore?.teamScore?.pf)
                  ?.map((x, ind) => {
                    return (
                      <div key={ind} className='row'>
                        <div className='row_1'>
                          <h2>{ind + 1}.</h2>
                        </div>
                        <div className='row_2'>
                          <div>
                            {x?.logo ? (
                              <img src={x?.logo} />
                            ) : (
                              <GiHockey size={50} color={'#fff'} />
                            )}
                          </div>
                          <h2>
                            {/* <span style={{ color: '#fff', opacity: '0.6', fontSize: '11px' }}>
                            {x?.conference}
                          </span>{' '}
                          <br /> */}
                            {x?.name || '-'}
                          </h2>
                        </div>
                        <div className='row_3'>
                          <h2 style={{ fontWeight: 400 }}>
                            {Number(x?.teamScore?.teamScore?.score)?.toFixed(2) || 0}
                          </h2>
                        </div>
                        <div className='row_4'>
                          <h2>{Number(x?.teamScore?.teamScore?.pf).toFixed(2) || 0}</h2>
                        </div>
                      </div>
                    )
                  })}
              </div>
            )
          })}
      </section>
    </div>
  )
}

export default LeagueStandingsHockey
